import { IPayoutInfluencer } from "@shared/lib/types/briefCampains";
import { Button, Modal } from "@shared/ui";
import { formatPayoutAmount } from "../../lib/payoutDisplay";
import styles from "./styles.module.scss";

type PayoutPayConfirmModalProps = {
  open: boolean;
  items: IPayoutInfluencer[];
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function PayoutPayConfirmModal({
  open,
  items,
  isSubmitting,
  onClose,
  onConfirm,
}: PayoutPayConfirmModalProps) {
  const total = items.reduce((sum, item) => sum + (item.amount || 0), 0);

  return (
    <Modal
      title="Pay selected payouts"
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="pay"
          type="primary"
          loading={isSubmitting}
          disabled={items.length === 0}
          onClick={onConfirm}
        >
          Create payment export
        </Button>,
      ]}
    >
      <div className={styles.total}>
        <div className={styles.totalLabel}>Total</div>
        <div className={styles.totalValue}>{formatPayoutAmount(total)}</div>
        <div className={styles.totalMeta}>
          {items.length} payout{items.length === 1 ? "" : "s"}
        </div>
      </div>
      <div className={styles.list}>
        {items.map((item) => (
          <div key={item.vendorPaymentId || item._id} className={styles.row}>
            <span>
              {item.campaignInfluencer?.influencerName ||
                item.campaignInfluencer?.socialMediaName}
              <span className={styles.campaign}>
                {" "}
                · {item.campaignInfluencer?.brief?.name}
              </span>
            </span>
            <span className={styles.amount}>
              {formatPayoutAmount(item.amount)}
            </span>
          </div>
        ))}
      </div>
    </Modal>
  );
}
